import { CLEAR_ALL, OKAY, VISUAL_HIERARCHY_LABELS, VH_MAX_SELECT_TEXT } from 'constants/constant';

export const MAX_OPTIONS_SELECT_LIMIT = 30;
export const BUTTON_LIST = [OKAY, CLEAR_ALL];
export const DATA_LOAD_SIZE = 10;
export const RIGHT_PANEL_HEADER = '';
export const LEFT_PANEL_HEADER = `${VISUAL_HIERARCHY_LABELS.DEPARTMENT} > ${VISUAL_HIERARCHY_LABELS.CATEGORY}`;
export const VH_MAX_SELECT_MESSAGE = VH_MAX_SELECT_TEXT.replace('{NN}', MAX_OPTIONS_SELECT_LIMIT);
export const SCROLL_EVENT = 'scroll';
export const LEFT_PANEL_CONTAINER_ID = 'list-container';
